<cb-drag-and-drop-document [(documentEntityMappedItem)]="documentEntityMappedItem"
                           (documentEntityMappedItemChange)="onDocumentEntityMappedItemChange()"></cb-drag-and-drop-document>
@if (!hideName && documentEntityMappedItem?.document) {
    <mat-form-field>
        <mat-label>Document Name</mat-label>
        <input matInput
               type="text"
               name="name"
               [maxlength]="100"
               required
               [(ngModel)]="documentEntityMappedItem.document.name" />
    </mat-form-field>
}
@if (!hideDescription && documentEntityMappedItem?.document) {
    <mat-form-field>
        <mat-label>Document Description</mat-label>
        <textarea #description
                  matInput
                  type="text"
                  name="subject"
                  [(ngModel)]="documentEntityMappedItem.document.description"
                  [maxlength]="500">
      </textarea>
        <mat-hint align="end">{{ description?.value.length }} / 500</mat-hint>
    </mat-form-field>
}
